// extracted by mini-css-extract-plugin
export default {"faceIdIconPath":"vGzTXY","fingerprintIconPath":"pzxHFl","quickLoginIconPath":"ow_wz9","genericBiometricIconPath":"HtPQDA"};